(() => {
  const widgetSelector = '[data-thp-cart-cross-sells]';
  const contextSelector = '[data-thp-cross-sell-product-id]';
  const observedWidgets = new WeakSet();

  function getContext(element) {
    const context = element?.closest?.(contextSelector);

    if (!context) return null;

    return {
      productId: context.dataset.thpCrossSellProductId || '',
      productTitle: context.dataset.thpCrossSellProductTitle || '',
      sourceProductId: context.dataset.thpCrossSellSourceProductId || '',
      position: Number(context.dataset.thpCrossSellPosition || 0),
    };
  }

  function publish(eventName, context, extra = {}) {
    if (!context) return;

    const detail = {
      item_list_id: 'cart_cross_sell',
      item_list_name: 'Cart cross-sell',
      product_id: context.productId,
      product_title: context.productTitle,
      source_product_id: context.sourceProductId,
      position: context.position,
      ...extra,
    };

    document.dispatchEvent(new CustomEvent(`thp:${eventName}`, { detail }));

    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({ event: `thp_${eventName}`, ...detail });
    }
  }

  function addAttributionFields(form, context) {
    if (!form || !context) return;

    const fields = {
      'properties[_thp_cross_sell]': 'true',
      'properties[_thp_cross_sell_source_product_id]': context.sourceProductId,
      'properties[_thp_cross_sell_position]': String(context.position),
    };

    Object.entries(fields).forEach(([name, value]) => {
      let input = form.elements.namedItem(name);

      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        form.appendChild(input);
      }

      input.value = value;
    });
  }

  function observeWidgets(root = document) {
    root.querySelectorAll(widgetSelector).forEach((widget) => {
      if (observedWidgets.has(widget)) return;

      observedWidgets.add(widget);

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          entry.target.querySelectorAll('.thp-cart-cross-sell-card').forEach((card) => {
            publish('cart_cross_sell_view', getContext(card));
          });

          observer.disconnect();
        });
      }, { threshold: 0.25 });

      observer.observe(widget);
    });
  }

  document.addEventListener('click', (event) => {
    const action = event.target.closest('[data-thp-cross-sell-action]');

    if (!action) return;

    publish('cart_cross_sell_select', getContext(action), {
      action: action.dataset.thpCrossSellAction,
    });
  });

  document.addEventListener('submit', (event) => {
    const form = event.target;
    const context = getContext(form);

    if (!context) return;

    addAttributionFields(form, context);
  }, true);

  document.addEventListener('variant:add', (event) => {
    const context = getContext(event.target);

    if (!context) return;

    publish('cart_cross_sell_add', context, {
      variant_id: String(event.detail?.items?.[0]?.variant_id || event.detail?.items?.[0]?.id || ''),
    });
  });

  document.addEventListener('DOMContentLoaded', () => observeWidgets());
  document.addEventListener('cart-drawer:refreshed', () => observeWidgets());
  document.addEventListener('dialog:after-show', (event) => {
    if (event.target.matches('cart-drawer')) observeWidgets(event.target);
  });
})();
